import { Component } from "./Component";

export enum ValidationResultType {
    REQUIRED = "required"
}

export interface ValidationResult {
    isValid: boolean;
    type?: ValidationResultType;
    validationMessage?: string;
    component: Component,
    caption?: string,
    componentToFocus?: Component
}
